/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { Card, Grid, Typography } from '@material-ui/core';
import { object, string } from 'prop-types';
import React from 'react';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import { transformCharacters } from '../../../../helpers/markdown/characterTransformer';
import LinkOrATag from '../../GraphqlCommonComponents/LinkOrATag/LinkOrATag';

const styles = (theme) => ({
    link: {
        width: '100%',
        height: '100%',
        display: 'inline-block',
        textDecoration: 'none',
        color: theme.palette.cms?.black || '#000',
        '& .MuiCard-root': {
            overflow: 'visible',
        },
    },
    card: {
        padding: '8px 8px 16px',
        height: '100%',
    },
    imageRoot: {
        width: '100%',
        paddingBottom: '109.09%', // DO NOT CHANGE pre-renders height according to img aspect ratio - only change if cdn height/width change
        borderRadius: 2,
        background: '#e3e3e3',
        boxShadow: '0 2px 4px 0 rgba(0,0,0,0.2)',
        position: 'relative',
        marginBottom: 12,
    },
    image: {
        display: 'block',
        width: 'inherit',
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        objectFit: 'cover',
        height: '100%',
    },
    lineClamp: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: '-webkit-box',
        WebkitBoxOrient: 'vertical',
    },
    title: {
        WebkitLineClamp: '2',
        fontWeight: 'bold',
        fontSize: '1rem',
        marginBottom: 8,
    },
    description: {
        WebkitLineClamp: '3',
        fontSize: '1rem',
    },
});

const GraphqlSimpleSearchElement = ({
    classes,
    title,
    image,
    description,
    redirectUrl,
    elementType,
}) => (
    <LinkOrATag
        id={`search-${elementType}-${title?.split(' ')?.join('-')?.toLowerCase()}`}
        dataTest={`search-${elementType}-element`}
        title={`${transformCharacters(title)}`}
        href={redirectUrl}
        className={classes.link}
        openInNewTab={elementType === 'article'}
        isTrackEventEnabled={elementType === 'article'}
        trackingEventCategory={elementType === 'article' ? 'searchrelatedarticles_interaction' : ''}
        trackingEventAction={elementType === 'article' ? 'Click' : ''}
        trackingEventLabel={elementType === 'article' ? `Card - ${transformCharacters(title)}` : ''}
    >
        <Card className={classes.card}>
            <Grid container>
                <Grid item className={classes.imageRoot}>
                    <img
                        src={image}
                        alt={title}
                        className={classes.image}
                        loading="lazy"
                    />
                </Grid>
                <Grid item xs={12}>
                    <Typography className={`${classes.lineClamp} ${classes.title}`}>
                        <span className={`${classes.title} transformedName`}>
                            {transformCharacters(title)}
                        </span>
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <Typography className={`${classes.lineClamp} ${classes.description}`}>
                        <span className={`${classes.description} transformedName`}>
                            {(transformCharacters(description?.replace(/(<([^>]+)>)/gi, '')))}
                        </span>
                    </Typography>
                </Grid>
            </Grid>
        </Card>
    </LinkOrATag>
);

GraphqlSimpleSearchElement.propTypes = {
    classes: object.isRequired,
    title: string.isRequired,
    image: string.isRequired,
    description: string.isRequired,
    redirectUrl: string.isRequired,
    elementType: string.isRequired,
};

const enhance = compose(
    withStyles(styles),
);

export default enhance(GraphqlSimpleSearchElement);
